import React from "react";
import { Paper, Box, Grid } from "@mui/material";
import ClientCountsChart from "../components/statistics/ClientCountsChart";
import ActiveClientCountsTable from "../components/statistics/ActiveClientCountsTable";
import IncomeLineChart from "../components/statistics/IncomeLineChart";
import IncomeTable from "../components/statistics/IncomeTable";

export const Statistics: React.FC = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
          }}>
          <Paper elevation={1} sx={{ height: '100%', overflow: 'hidden' }}>
            <ClientCountsChart />
          </Paper>
        </Grid>
        <Grid
          size={{
            xs: 12,
          }}>
          <Paper elevation={1} sx={{ height: '100%', overflow: 'hidden' }}>
            <IncomeLineChart />
          </Paper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <Paper elevation={1} sx={{ overflow: 'hidden' }}>
            <ActiveClientCountsTable />
          </Paper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <Paper elevation={1}>
            <IncomeTable />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
